export const COMMISSIONS_LIST_FILTER_CHANGED = 'commissions_list.filter.changed'
